import { FC } from "react";
import { Container } from "react-bootstrap";

import ImageTile from "../Shared/Banner/RegionalBanner/ImageTile";
import DiscoverJourney from "../Shared/RegionalPages/DiscoverJourney";
import DrivingTogether from "../Shared/RegionalPages/DrivingTogether";
import EmployeeLoves from "../Shared/RegionalPages/EmployeeLoves";
import Testimonial from "../Shared/RegionalPages/Testimonial";

import { INDIA_KEY } from "../../utils/_active_regions";
import {
  INDIA_DRIVING_TOGETHER,
  INDIA_JOURNEY,
  INDIA_TESTIMONIALS,
} from "./_static";

import banner_1 from "../../assets/images/india/banner_1.webp";
import banner_2 from "../../assets/images/india/banner_2.webp";
import banner_3 from "../../assets/images/india/banner_3.webp";
import banner_4 from "../../assets/images/india/banner_4.webp";
import banner_5 from "../../assets/images/india/banner_5.webp";
import banner_6 from "../../assets/images/india/banner_6.webp";

const images = [banner_1, banner_2, banner_3, banner_4, banner_5, banner_6];

const IMAGETILE_PROPS = {
  images,
  region: INDIA_KEY,
  title: "page.regional.middle_east.banner.title",
  description: "page.regional.middle_east.banner.description",
};

const India: FC = () => {
  return (
    <>
      <ImageTile {...IMAGETILE_PROPS} />
      <Container>
        <div id="discover-journey">
          <DiscoverJourney {...INDIA_JOURNEY} />
        </div>
        <DrivingTogether {...INDIA_DRIVING_TOGETHER} />
        <EmployeeLoves region={INDIA_KEY} />
        <Testimonial items={INDIA_TESTIMONIALS} />
      </Container>
    </>
  );
};
export default India;
